import { postFetch } from "../../../../../fetch/fetch";

// (자체화) Todoist Sync API 대신 자체 백엔드(/dashboard/todoist/*) 호출.
// 함수 시그니처는 그대로 유지(호출부 무수정). apiKey 인자는 더 이상 사용하지 않음.

const updateTaskBySyncApi = async (type : string, taskId: any, data: any, apiKey? : string) => {

    // type: 'item_update' = 필드 수정(content/due/priority). 상태 변경은 setStatus 사용.
    const result : any = await postFetch("/dashboard/todoist/updateTask", {
        taskV2Id: taskId,
        type,
        data
    });

    console.log(result);

    return result;

}

// parentV2Id 를 주면 그 task 의 하위 항목으로 생성 (서버 /createTask → todo_tasks.parentId)
const AddTaskBySyncApi = async (content : string, project_id : string | null, section_id : string | null, apiKey? : string, parentV2Id? : string | null) => {

    const result : any = await postFetch("/dashboard/todoist/createTask", {
        content,
        projectV2Id: project_id,
        sectionV2Id: (!section_id || section_id === "none") ? null : section_id,
        parentV2Id: parentV2Id ? parentV2Id : null
    });

    console.log(result);

    return result;

}

const reorderTaskBySyncApi = async (type : string, data: any, apiKey? : string) => {

    // data: [{ id: <task v2_id>, child_order }]
    const result : any = await postFetch("/dashboard/todoist/reorder", {
        items: data
    });

    console.log(result);

    return result;

}

function convertLocalPathToPublicUrl(localPath : string) {

    if(!localPath) return "";

    // '/public'를 기준으로 문자열을 분할합니다.
    // 예: "/home/centos/peetsunbae/dist/public/img/message/chat_img-123.jpeg"
    //     => splitted = ["/home/centos/peetsunbae/dist", "/img/message/chat_img-123.jpeg"]
    const splitted = localPath.split('/public');

    // 만약 '/public'라는 구분자가 없으면, 그냥 원본 경로를 반환(에러 처리)
    if (splitted.length < 2) {
      return localPath;
    }

    // splitted[1]의 값은 예: "/img/message/chat_img-123.jpeg"
    // 앞에 우리가 원하는 도메인을 붙여 최종 URL 만듭니다.
    // "https://peetsunbae.com/img/message/chat_img-123.jpeg"
    return 'https://peetsunbae.com' + splitted[1];
  }


const addANoteToATask = async (type : any, taskId : string, data : string, apiKey? : string) => {

    // type === "text": data = 본문 / type === "img": data = 업로드된 /public 경로 / type === "video": data = R2 풀 URL
    const result : any = await postFetch("/dashboard/todoist/addNote", {
        taskV2Id: taskId,
        kind: type,
        content: type === "text" ? data : "",
        imageUrl: type === "img" ? convertLocalPathToPublicUrl(data) : type === "video" ? data : null
    });

    console.log(result);

    return result;

}

export { updateTaskBySyncApi, reorderTaskBySyncApi, addANoteToATask, convertLocalPathToPublicUrl, AddTaskBySyncApi };
